import { p as promiseResolve, b as bootstrapLazy } from './index-f94e56f0.js';

/*
 Stencil Client Patch Esm v2.6.0 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["fm-backdrop",[[1,"fm-backdrop"]]],["fm-loader",[[1,"fm-loader",{"show":[32],"showLoader":[64]}]]],["fm-toast",[[0,"fm-toast",{"message":[32],"toastType":[32],"showToast":[64]}]]]], options);
  });
};

export { defineCustomElements };
